import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  IconButton
} from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';

export default function EditServiceModal({ open, onClose, data }) {
  const [formData, setFormData] = useState({ company: '', product_name: '' });

  useEffect(() => {
    if (data) setFormData({ company: data.company, product_name: data.product_name });
  }, [data]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{
          bgcolor: '#3F90DF',
          color: '#fff',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        Edit Service Information
        <IconButton onClick={onClose} sx={{ color: '#fff' }}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ bgcolor: '#161C24', pt: 4 }}>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Company Name"
              value={formData.company}
              onChange={(e) => setFormData({ ...formData, company: e.target.value })}
              sx={{
                input: { color: '#fff' },
                '& label': { color: '#9CA3AF' },
                '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#333' } }
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Product Name"
              value={formData.product_name}
              onChange={(e) => setFormData({ ...formData, product_name: e.target.value })}
              sx={{
                input: { color: '#fff' },
                '& label': { color: '#9CA3AF' },
                '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#333' } }
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ bgcolor: '#161C24', p: 3, borderTop: '1px solid #333' }}>
        <Button onClick={onClose} sx={{ color: '#fff' }}>
          Cancel
        </Button>
        <Button variant="contained" sx={{ bgcolor: '#3F90DF' }}>
          Update Service
        </Button>
      </DialogActions>
    </Dialog>
  );
}
